exports = module.exports = require("../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ele-editable .el-form-item{margin-bottom:0}.ele-editable .el-icon-loading{font-size:24px;color:#409eff;-webkit-animation:rotating 1s linear infinite;animation:rotating 1s linear infinite}.ele-editable__empty{color:#f56c6c;font-style:italic}.ele-editable__edit,.ele-editable__empty{cursor:pointer;border-bottom:1px dashed #409eff}.ele-editable__edit{color:#409eff}", ""]);

// exports
